import React from "react"
import Modal from "aldoo-ra/Modal"
import Button from "aldoo-ra/Button"
import Typography from "aldoo-ra/Typography"

const FailedKeysModal = ({ isOpen, onClose, failedKeys }) => {
  // Group failures by error type for better organization
  const errorGroups = {}

  if (failedKeys) {
    failedKeys.forEach((failKey) => {
      const errorType = failKey.error || "Unknown error"
      if (!errorGroups[errorType]) {
        errorGroups[errorType] = []
      }
      errorGroups[errorType].push(failKey)
    })
  }

  return (
    <Modal
      variant="admin"
      isOpen={isOpen}
      onClose={onClose}
      className="relative sm:w-[700px] sm:max-w-[90vw] h-full md:h-auto"
      title="Failed Localization Keys"
    >
      <div className="p-6 overflow-auto max-h-[80vh]">
        {failedKeys && failedKeys.length > 0 ? (
          <div>
            <Typography variant="admin_h3" className="mb-4">
              {failedKeys.length} keys failed to process
            </Typography>

            {/* Error type breakdown */}
            <div className="mb-6">
              <Typography
                variant="admin_h4"
                className="!font-semibold mb-2"
              >
                Error Summary
              </Typography>
              {Object.keys(errorGroups).map((errorType, idx) => (
                <div key={idx} className="mb-2">
                  <Typography variant="admin_body">
                    {errorType}: {errorGroups[errorType].length} occurrences
                  </Typography>
                </div>
              ))}
            </div>

            {/* List of all failed keys */}
            <div>
              <Typography
                variant="admin_body_accent"
                className="mb-2"
              >
                Failed Keys Details
              </Typography>
              <div className="border rounded overflow-hidden">
                {failedKeys.map((failedKey, index) => (
                  <div
                    key={index}
                    className={`p-3 ${
                      index % 2 === 0 ? "bg-admin_neutral_1" : "bg-admin_paper"
                    } border-b last:border-b-0`}
                  >
                    <div className="flex flex-col">
                      <Typography
                        variant="admin_body"
                        className="font-semibold mb-1"
                      >
                        {index + 1}. {failedKey.key}
                      </Typography>
                      <Typography
                        variant="admin_txt"
                        className="text-admin_text mb-1"
                      >
                        Content Type:{" "}
                        <span className="font-medium">
                          {failedKey.contentType}
                        </span>{" "}
                        | Field:{" "}
                        <span className="font-medium">{failedKey.fieldId}</span>{" "}
                        | Field Type:{" "}
                        <span className="font-medium">
                          {failedKey.fieldType}
                        </span>
                      </Typography>
                      <Typography variant="admin_txt" className="text-admin_error">
                        Error: {failedKey.error}
                      </Typography>
                      {failedKey.contentPreview && (
                        <Typography
                          variant="admin_txt"
                          className="text-admin_text mt-1"
                        >
                          Content preview:{" "}
                          <span className="font-mono text-xs bg-admin_neutral_1 p-1 rounded">
                            {failedKey.contentPreview}
                          </span>
                        </Typography>
                      )}
                      {failedKey.originalValue && (
                        <Typography
                          variant="admin_txt"
                          className="text-admin_text mt-1"
                        >
                          Original value:{" "}
                          <span className="font-mono text-xs bg-admin_neutral_1 p-1 rounded">
                            {failedKey.originalValue}
                          </span>
                        </Typography>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        ) : (
          <Typography
            variant="admin_body"
            className="text-center my-8"
          >
            No failed keys information available
          </Typography>
        )}

        <div className="flex justify-center mt-6">
          <Button
            variant="admin_primary"
            className="w-full sm:w-32"
            onClick={onClose}
          >
            Close
          </Button>
        </div>
      </div>
    </Modal>
  )
}

export default FailedKeysModal
